import api from '../_api';

export default {
  namespaced: true,
  state: {
    current: {},
    isLoading: false,
  },
  actions: {
    async fetchNotification ({ commit, },notificationId,) {
      commit('notification/setNotification', {}, { root: true, },);
      commit('notification/setLoading', true, { root: true, },);

      try {
        await api.getById(notificationId,).then(({data: response, },) => {
          commit('notification/setNotification', response, { root: true, },);
          return response;
        },);
      } catch (error) {
        return api.handleError(error,);
      } finally {
        commit('notification/setLoading', false, { root: true, },);
      }
    },
    async editNotification (_, { notificationId, formData, },) {
      await api.edit(notificationId,formData,);
    },
    async saveNotification (_, formData,) {
      await api.create(formData,);
    },
    uploadCSV (_, csvData,) {
      return api.uploadCSV(csvData,);
    },
    uploadImage (_, imageData,) {
      return api.uploadImage(imageData,);
    },
    deleteNotication (_, notificationId,) {
      return api.deleteNotication(notificationId,);
    },
  },
  mutations: {
    setNotification: (state, data,) => state.current = data,
    setLoading: (state, data,) => state.isLoading = data,
  },
  getters: {
    currentNotification: (state,) => state.current,
    isLoading: (state,) => state.isLoading,
  },

};
